import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs'
import { closeJobSelectionDialog } from '../../../../shared/utils/job-selection-dialog-utils'

@Component({
    selector: 'app-generic-registration-selection',
    templateUrl: './generic-registration-selection.component.html',
    styleUrls: ['./generic-registration-selection.component.scss'],
})
export class GenericRegistrationSelectionComponent<T extends { name?: string | undefined }> {
    private _sourceLayers$: Observable<T[]>
    get sourceLayers$(): Observable<T[]> {
        return this._sourceLayers$
    }
    @Input()
    set sourceLayers$(layers$: Observable<T[]>) {
        this.selectedTargetLayer = null
        this.selectedSourceLayers = null
        this._sourceLayers$ = layers$
    }

    @Input()
    startJobFn:
        | ((
              targetLayer: string | undefined,
              sourceLayers: (string | undefined)[],
              batch: boolean
          ) => void)
        | null

    @Input()
    siblingDatasets: string[] | never[]

    selectedTargetLayer: T | null
    submitted: boolean = false
    runBatchJob: boolean = false
    private selectedSourceLayers: T[] | null

    get canStart(): boolean {
        return (
            !!this.selectedTargetLayer &&
            !!this.selectedSourceLayers &&
            this.selectedSourceLayers.length > 0 &&
            !this.submitted
        )
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    startJob(): void {
        if (!this.canStart) return
        this.submitted = true

        this.startJobFn?.(
            this.selectedTargetLayer!.name ?? undefined,
            this.selectedSourceLayers!.map(layer => layer.name),
            this.runBatchJob
        )
    }

    selectTargetLayer(layer: T): void {
        this.selectedTargetLayer = layer
    }

    selectSourceLayers(layers: T[]): void {
        this.selectedSourceLayers = layers
    }
}
